import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";

const initialState = {
  permissionData: [],
  departments: [],
  uimodules: [],
  usersunderdpt: [],
  relationShips: [],
  loading: false,
};

export const getallPermissions = createAsyncThunk(
  "permission/allpermissions",
  async (data) => {
    const res = await apiRequest({
      method: "get",
      url: `permissions?dept_id=${data.department}&page=${data.page}&limit=${data.limit}&search=${data.search}`,
    });
    // console.log("Permission Get", res);
    return res;
  }
);

export const addPermission = createAsyncThunk(
  "permission/addpermissions",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: "permissions",
      data: data,
    });
    // console.log("Permission Post", res);
    return res;
  }
);

export const updatePermission = createAsyncThunk(
  "permission/updatepermissions",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: "permissions",
      data: data,
    });
    // console.log("Permission update", res);
    return res;
  }
);
export const getAlldepartments = createAsyncThunk(
  "permission/alldepartments",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: "department-management/getDepartments?page=1&limit=no",
    });
    // console.log("dpt Get", res);
    return res;
  }
);

export const getAllUimodules = createAsyncThunk(
  "permission/getuimodules",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `ui-modules?page=1&limit=no`,
    });
    // console.log("uimodule Get", res);
    return res;
  }
);

export const DeletePermissions = createAsyncThunk(
  "permission/deletepermissions",
  async (permissionID) => {
    const res = await apiRequest({
      method: "delete",
      url: `permissions/${permissionID}`,
    });
    // console.log("delete", res);
    return res;
  }
);
export const getUsersUnderDepartment = createAsyncThunk(
  "permission/getuserunderdepartment",
  async (departmentID) => {
    const res = await apiRequest({
      method: "get",
      url: `department-management/getEmployees/${departmentID}`,
    });
    // console.log("uimodule Get", res);
    return res;
  }
);

export const addPermissionRelation = createAsyncThunk(
  "permission/addpermissionrelation",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: "permissions/relations",
      data: data,
    });
    // console.log("relation Post", res);
    return res;
  }
);

// Grant a permission to every user role currently under a department in one
// action (data: { permissionId, departmentId }), instead of picking users one
// by one. One-time bulk grant — roles added to the department later need this
// re-run to pick up the permission.
export const addPermissionRelationByDepartment = createAsyncThunk(
  "permission/addpermissionrelationbydepartment",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: "permissions/relations/department",
      data: data,
    });
    return res;
  }
);

export const getallPermissionsRelationShips = createAsyncThunk(
  "permission/getallPermissionsRelationShips",
  async (permissionId) => {
    const res = await apiRequest({
      method: "get",
      url: `/permissions/relations?permissionID=${permissionId}`,
    });
    return res;
  }
);
export const deleteRelationShipId = createAsyncThunk(
  "permission/deleteRelationShipId",
  async (id) => {
    const res = await apiRequest({
      method: "delete",
      url: `/permissions/relations/${id}`,
    });
    return res;
  }
);

const permissionSlice = createSlice({
  name: "permission",
  initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getallPermissions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getallPermissions.fulfilled, (state, action) => {
      state.loading = false;
      state.permissionData = action.payload;
    });
    builder.addCase(addPermission.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addPermission.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(addPermission.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    // ------------------------------------update--------------------------------
    builder.addCase(updatePermission.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updatePermission.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updatePermission.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getAlldepartments.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAlldepartments.fulfilled, (state, action) => {
      state.loading = false;
      state.departments = action.payload.data;
    });
    builder.addCase(getAllUimodules.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllUimodules.fulfilled, (state, action) => {
      state.loading = false;
      state.uimodules = action.payload.data;
    });
    builder.addCase(DeletePermissions.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(DeletePermissions.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    builder.addCase(getUsersUnderDepartment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUsersUnderDepartment.fulfilled, (state, action) => {
      state.loading = false;
      state.usersunderdpt = action.payload.data;
    });
    builder.addCase(addPermissionRelation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addPermissionRelation.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(addPermissionRelation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(addPermissionRelationByDepartment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addPermissionRelationByDepartment.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(addPermissionRelationByDepartment.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getallPermissionsRelationShips.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getallPermissionsRelationShips.fulfilled,
      (state, action) => {
        state.loading = false;
        state.relationShips = action.payload;
      }
    );
    builder.addCase(deleteRelationShipId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteRelationShipId.fulfilled, (state, action) => {
      state.loading = false;
    });
  },
});

// export const { apiCallData } = permissionSlice.actions;

export default permissionSlice.reducer;
